<template>
  <div :class="{ 'total-products-results-container': showNote }">
    <v-data-table fixed-header disable-pagination hide-default-footer :headers="headers" :items="items" no-data-text="Sem dados">
      <template v-if="hasIdAndName" v-slot:[`item._id`]="{ item }">
        <span>{{ item._id }}</span>
      </template>
      <template v-if="hasIdAndName" v-slot:[`item.name`]="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:[`item.clients`]="{ item }">
        {{ item.clients | localeString }}
      </template>
      <template v-slot:[`item.tickets`]="{ item }">
        {{ item.tickets | localeString }}
      </template>
      <template v-slot:[`item.quantity`]="{ item }">
        {{ item.quantity | localeString }}
      </template>
      <template v-slot:[`item.revenue`]="{ item }">
        <span>{{ locale(item.revenue, 2) | localeString(2) | currency }}</span>
      </template>
      <template v-slot:[`item.impact`]="{ item }">
        {{ locale(item.impact, 2) | localeString(2) | percent }}
      </template>
    </v-data-table>

    <span v-if="showNote" class="products-label"> No próximo slide você pode ver o resultado por produto (Limite máximo de 10 produtos) </span>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ProductsResultsTable',
  props: {
    metrics: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'products',
      validator: (value) => ['products', 'total'].includes(value),
    },
  },
  data: () => ({
    locale: localeString,
  }),
  computed: {
    hasIdAndName() {
      return this.type === 'products'
    },
    showNote() {
      return this.type === 'total'
    },
    headers() {
      const baseHeaders = [
        { text: 'Clientes que compraram', value: 'clients', sortable: false },
        { text: 'Cupons fiscais', value: 'tickets', sortable: false },
        { text: 'Unidades vendidas', value: 'quantity', sortable: false },
        { text: 'Faturamento', value: 'revenue', sortable: false },
        { text: 'Impacto', value: 'impact', sortable: false },
      ]

      if (this.hasIdAndName) {
        baseHeaders.unshift({ text: 'Código', value: '_id', sortable: false }, { text: 'Produto', value: 'name', sortable: false })
      }

      return baseHeaders
    },
    items() {
      if (this.type === 'products') {
        const table = this.metrics?.products_metrics?.table
        if (!table || !Array.isArray(table)) return []
        return table
          .map((row) => ({
            _id: row.product.sku,
            name: row.product.name,
            quantity: row.received.quantity,
            revenue: row.received.revenue,
            tickets: row.received.tickets,
            clients: row.received.clients,
            impact: row.received.impactedPercentage,
          }))
          .slice(0, 10)
      }

      const total = this.metrics?.products_metrics?.productsTotalMetrics
      return [
        {
          quantity: total?.quantity,
          revenue: total?.revenue,
          tickets: total?.tickets,
          clients: total?.clients,
          impact: total?.impactedPercentage,
        },
      ]
    },
  },
  methods: {
    localeString,
  },
}
</script>

<style lang="scss" scoped>
.total-products-results-container {
  display: flex;
  flex-direction: column;
  gap: 100px;
  justify-content: center;

  .products-label {
    text-align: center;
    color: $marca-0-l20;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
}

::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  border-left: 1px solid #eee;
}

::v-deep thead th {
  border-bottom: 1px solid #eee !important;
}

::v-deep .v-data-table-header tr,
::v-deep .v-data-table-header th {
  background: #fff !important;
  border-top: 1px solid #fff !important;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 12px;
    line-height: 1;
    border-left: 1px solid #eee;
  }

  td:first-child {
    border-left: none;
  }
}

::v-deep th:first-child {
  border-left: none;
}
</style>
